import React, { useEffect, useState } from "react";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";
import SuicidalThoughtsAndBehaviorsView from "../mood/SuicidalThoughtsAndBehaviorsView";


const Definition: QuestionnaireDefinition = {
  name: 'Patient Health Questionnaire-9',
  key: 'patientHealthQuestionnaire',
  title: 'Patient Health Questionnaire-9',
  description: '',
  cohort: 'generic',
  type: 'questionnaire',
  estimatedCompletionTime: '1:20',
  groups: [
    {
      key: 'phq9',
      description: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
      questions: [
        {
          // The key is REDCap model.
          key: 'noInterest',
          type: 'multiple-choice',
          question: 'Little interest or pleasure in doing things.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'feelingDepressed',
          type: 'multiple-choice',
          question: 'Feeling down, depressed, or hopeless.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'troubleSleeping',
          type: 'multiple-choice',
          question: 'Trouble falling or staying asleep, or sleeping too much.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'noEnergy',
          type: 'multiple-choice',
          question: 'Feeling tired or having little energy.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'noAppetite',
          type: 'multiple-choice',
          question: 'Poor appetite or overeating.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'feelingBadSelf',
          type: 'multiple-choice',
          question: 'Feeling bad about yourself - or that you are a failure or have let yourself or your family down.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'troubleConcentrate',
          type: 'multiple-choice',
          question: 'Trouble concentrating on things, such as reading the newspaper or watching television.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'moveSpeakSlow',
          type: 'multiple-choice',
          question: 'Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'thoughtsDeath',
          type: 'multiple-choice',
          question: 'Thoughts that you would be better off dead or of hurting yourself in some way.',
          options: [
            { key: '0', displayName: 'Not at all' },
            { key: '1', displayName: 'Several days' },
            { key: '2', displayName: 'More than half the days' },
            { key: '3', displayName: 'Nearly every day' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'selection',
          type: 'multiple-choice',
          question: 'How difficult have they made it for you to do your work, take care of things at home, or get along with other people?',
          options: [
            { key: '0', displayName: 'Not difficult at all' },
            { key: '1', displayName: 'Somewhat difficult' },
            { key: '2', displayName: 'Very difficult' },
            { key: '3', displayName: 'Extremely difficult' }
          ],
          value:  '',
          defaultValue: '',
          required: true,
          condition: (questionnaire: Questionnaire) => {
            const group = questionnaire.groups.find(group => group.key === 'phq9');
            const noInterestQuestion = group?.questions.find(question => question.key === 'noInterest');
            const feelingDepressedQuestion = group?.questions.find(question => question.key === 'feelingDepressed');
            const troubleSleepingQuestion = group?.questions.find(question => question.key === 'troubleSleeping');
            const noEnergyQuestion = group?.questions.find(question => question.key === 'noEnergy');
            const noAppetiteQuestion = group?.questions.find(question => question.key === 'noAppetite');
            const feelingBadSelfQuestion = group?.questions.find(question => question.key === 'feelingBadSelf');
            const troubleConcentrateQuestion = group?.questions.find(question => question.key === 'troubleConcentrate');
            const moveSpeakSlowQuestion = group?.questions.find(question => question.key === 'moveSpeakSlow');
            const thoughtsDeathQuestion = group?.questions.find(question => question.key === 'thoughtsDeath');
            const noInterestQuestionValue = noInterestQuestion ? Number(noInterestQuestion.value) : null;
            const feelingDepressedQuestionValue = feelingDepressedQuestion ? Number(feelingDepressedQuestion.value) : null;
            const troubleSleepingQuestionValue = troubleSleepingQuestion ? Number(troubleSleepingQuestion.value) : null;
            const noEnergyQuestionValue = noEnergyQuestion ? Number(noEnergyQuestion.value) : null;
            const noAppetiteQuestionValue = noAppetiteQuestion ? Number(noAppetiteQuestion.value) : null;
            const feelingBadSelfQuestionValue = feelingBadSelfQuestion ? Number(feelingBadSelfQuestion.value) : null;
            const troubleConcentrateQuestionValue = troubleConcentrateQuestion ? Number(troubleConcentrateQuestion.value) : null;
            const moveSpeakSlowQuestionValue = moveSpeakSlowQuestion ? Number(moveSpeakSlowQuestion.value) : null;
            const thoughtsDeathQuestionValue = thoughtsDeathQuestion ? Number(thoughtsDeathQuestion.value) : null;

            return (noInterestQuestionValue !== null && noInterestQuestionValue > 0) ||
                (feelingDepressedQuestionValue !== null && feelingDepressedQuestionValue > 0) ||
                (troubleSleepingQuestionValue !== null && troubleSleepingQuestionValue > 0) ||
                (noEnergyQuestionValue !== null && noEnergyQuestionValue > 0) ||
                (noAppetiteQuestionValue !== null && noAppetiteQuestionValue > 0) ||
                (feelingBadSelfQuestionValue !== null && feelingBadSelfQuestionValue > 0) ||
                (troubleConcentrateQuestionValue !== null && troubleConcentrateQuestionValue > 0) ||
                (moveSpeakSlowQuestionValue !== null && moveSpeakSlowQuestionValue > 0) ||
                (thoughtsDeathQuestionValue !== null && thoughtsDeathQuestionValue > 0);
            }
          }
      ]
    }
  ]
};

export const PHQ9Definition = Definition;

export const PHQ9 = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'patientHealthQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  const [thoughtsDeathValue, setThoughtsDeathValue] = useState<string | Date | string[] | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (thoughtsDeathValue !== null && Number(thoughtsDeathValue) > 0) {
      setDialogOpen(true);
    }
  }, [thoughtsDeathValue]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  console.log('PHQ9 component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('PHQ9 completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    const thoughtsDeathQuestion = questionnaire.groups
    .find(group => group.key === 'phq9')?.questions
    .find(question => question.key === 'thoughtsDeath');

    if (thoughtsDeathQuestion) {
      setThoughtsDeathValue(thoughtsDeathQuestion.value);
    }
    setQuestionnaire(questionnaire);
  }

  console.log('PHQ9 component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
      <SuicidalThoughtsAndBehaviorsView open={dialogOpen} onClose={handleDialogClose} />
    </div>
  );
}
